/**
 * Notification system composable — initializes NotificationService lifecycle.
 */

import { ref, readonly } from 'vue';
import notificationService from '@/domains/notifications/services/NotificationService';

/**
 * System-level notifications initialization (App.vue, auth views).
 */
export function useNotificationSystem() {
  const isInitialized = ref(false);
  const initError = ref(null);

  const initialize = async () => {
    if (isInitialized.value) {
      return;
    }

    try {
      await notificationService.initialize();
      isInitialized.value = true;
      initError.value = null;
    } catch (error) {
      console.error('[useNotificationSystem] Initialization failed:', error);
      initError.value = error;
    }
  };

  const cleanup = () => {
    notificationService.cleanup();
    isInitialized.value = false;
  };

  return {
    initialize,
    cleanup,
    isInitialized: readonly(isInitialized),
    initError: readonly(initError),
  };
}
